var BILLING_ADDRESS = 'BILLING_ADDRESS';
var SHIPPING_ADDRESS = 'SHIPPING_ADDRESS';
var SITE_ADDRESS = 'SITE_ADDRESS';
export var ADDRESS = {
  CITY: 'city',
  COUNTRY: 'country',
  LINE1: 'line1',
  LINE2: 'line2',
  PIN_CODE: 'pinCode',
  POSTAL_CODE: 'postalCode',
  STATE: 'state',
  TYPE: 'type'
};
export var ADDRESS_TYPE = {
  BILLING_ADDRESS: 2,
  SHIPPING_ADDRESS: 1,
  SITE_ADDRESS: 0
};
export var ADDRESS_TYPE_ENUMS = {
  BILLING_ADDRESS: BILLING_ADDRESS,
  SHIPPING_ADDRESS: SHIPPING_ADDRESS,
  SITE_ADDRESS: SITE_ADDRESS
};